<template>
  <div>
    <v-card>
      <v-card-title>
        {{ course.name }}
      </v-card-title>

      <v-card-text>
        <v-autocomplete
          v-model="currentStudentSearch"
          :items="studentsResult"
          :loading="isLoading"
          :search-input.sync="searchStudent"
          color="primary"
          hide-no-data
          hide-selected
          item-text="full_name"
          item-value="id"
          placeholder="Buscar estudiante"
          return-object
        ></v-autocomplete>
        <v-textarea
          outline
          label="Notas"
          name="notes"
          v-model="notes"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="$emit('closeModal')">Cancelar</v-btn>
          <v-btn
            @click="registerStudent"
            color="primary"
            :disabled="this.currentStudentSearch ? false : true">Registrar</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'new-student-assistance-view',
    props: {
      course: {
        type: Object,
        required: false
      },
      schedule_id: {
        type: Number,
        required: false
      },
      currentAssistance: {
        type: Array,
        required: false
      },
      register_date: {
        type: Number,
        required: false
      }
    },
    data() {
      return {
        isLoading: false,
        searchStudent: null,
        entries: [],
        currentStudentSearch: null,
        studentNameMaxLength: 80,
        notes: ''
      }
    },
    watch: {
      currentStudentSearch: function(newVal, oldval) {
        if (newVal) {
          this.isLoading = true
          axios.get(`/api/extracurriculares/admin/enrollment/student/${newVal.id}`)
          .then(res => {
            const { data } = res
            this.studentFound = data.student
            this.isLoading = false
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.isLoading = false))
        }
      },
      searchStudent(val) {
        if (!val) return
        if (this.isLoading) return

        this.isLoading = true
        this.available = false
        this.studentRestrictions = {}
        this.shcedulesValidations = {}
        axios.get(`/api/extracurriculares/admin/enrollment/search_student/${val}`)
          .then(res => {
            const { data } = res
            let available = false
            let student_exists = false
            const course = this.$props.course
            this.entries = data.filter(student => {
              available = false
              if (course.grades) {
                available = course.grades
                  .split(', ')
                  .includes(student.grade_level)
              }

              if (course.ages) {
                const ages = course.ages
                  .split(' - ')
                  .map(age => parseInt(age, 10))
                  available = student.age >= ages[0] && student.age <= ages[1]
              }

              student_exists = this.$props.currentAssistance.
                filter(assistance => assistance.student_id == student.id)
                .length > 0

              return available && !student_exists
            })
          })
          .catch(err => {
          })
          .finally(() => (this.isLoading = false))
      },
    },
    computed: {
      studentsResult() {
        return this.entries.map(student => {
          student.full_name.length > this.studentNameMaxLength
            ? student.full_name.slice(0, this.studentNameMaxLength) + '...'
            : student.full_name

          return Object.assign({}, student)
        })
      }
    },
    methods: {
      registerStudent() {
        const course_id = this.$props.course.id
        const schedule_id = this.$props.schedule_id
        const register_date = this.$props.register_date
        const student_id = this.currentStudentSearch.id
        const notes = this.notes

        axios.post('/api/extracurriculares/course/assistance/register', {
          course_id,
          schedule_id,
          student_id,
          notes,
          register_date
        })
        .then(resp => {
          if (resp.status === 200) {
            this.init()
            this.$emit('closeModal')
          }
        })
        .catch(error => console.log(error))
      },
      init() {
        this.currentStudentSearch = null
        this.entries = []
        this.searchStudent= null
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/teacher/new_assistance.vue